import { useState, useEffect } from 'react';
import { Playlist, Song } from '../types';

export const usePlaylist = (songs: Song[]) => {
  const [currentPlaylist, setCurrentPlaylist] = useState<Playlist | null>(null);
  const [isPlaylistMenuOpen, setIsPlaylistMenuOpen] = useState(false);
  
  // Load saved playlist from localStorage
  useEffect(() => {
    const savedPlaylistId = localStorage.getItem('vibeCurrentPlaylist');
    if (savedPlaylistId && currentPlaylist && currentPlaylist.id !== savedPlaylistId) {
      // We'll set this in the parent component when playlists are loaded
      // This just handles the side effect
    }
  }, [currentPlaylist]);
  
  // Save selected playlist to localStorage
  useEffect(() => {
    if (currentPlaylist) {
      localStorage.setItem('vibeCurrentPlaylist', currentPlaylist.id);
    }
  }, [currentPlaylist]);
  
  // Get a random song that's different from the given ID
  const getRandomSong = (excludeSongId?: string): Song | null => {
    if (!currentPlaylist || !songs.length) return null;
    
    // Filter songs to only include those in the current playlist
    const playlistSongs = songs.filter(song => 
      currentPlaylist.songIds.includes(song.id)
    );
    
    if (playlistSongs.length === 0) return null;
    if (playlistSongs.length === 1) return playlistSongs[0];
    
    let songOptions = excludeSongId 
      ? playlistSongs.filter(song => song.id !== excludeSongId) 
      : playlistSongs;
    
    // If we filtered out all songs, use the original list
    if (songOptions.length === 0) songOptions = playlistSongs;
    
    const randomIndex = Math.floor(Math.random() * songOptions.length);
    return songOptions[randomIndex];
  };

  return {
    currentPlaylist,
    setCurrentPlaylist,
    isPlaylistMenuOpen,
    setIsPlaylistMenuOpen,
    getRandomSong
  };
}; 